module.exports = require('./lib/visibility.timers.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/visibilityjs/index.js
// module id = 834
// module chunks = 1